<script>
  import Pane from "$lib/Elements/Pane.svelte";
  import { definitions, jobs } from "../store";
  import InputWrapper from "./InputWrapper.svelte";

  let workflow;
  export let context;
  export { workflow as definition };
  export let isReadonly;

  let properties = workflow.properties;
  let currentJob = jobs.currentJob;

  function onPropertyChanged(property, value) {
    properties[property] = value;
    context.notifyPropertiesChanged();
  }

  function shouldDisplayProperty(property) {
    return property !== "global_context";
  }

  function jobInfo({ status, app }) {
    return { status, app };
  }
</script>

{#if $currentJob}
  <Pane class="p-4 mb-4">
    <h3 class="font-semibold text-sm text-gray-400 pb-5">Job {$currentJob.id}</h3>

    <div class="font-semibold mb-4">{$currentJob.device}</div>

    <div class="grid grid-cols-2 gap-y-1">
      {#each Object.entries(jobInfo($currentJob)) as [key, value] (key)}
        <div class="capitalize">{key}</div>
        <div class="font-semibold">{value}</div>
      {/each}
    </div>
  </Pane>
{/if}

<Pane>
  <h3 class="font-semibold px-4 text-sm text-gray-400 pb-5">Workflow Settings</h3>

  <div class="px-3 mb-4">
    <h4 class="font-semibold mb-4">Properties</h4>
    {#each Object.entries(definitions.getRootDefinitions()) as [property, propertyType]}
      {#if shouldDisplayProperty(property)}
        <InputWrapper
          {properties}
          {property}
          {propertyType}
          {isReadonly}
          step={{ id: null }}
          on:change={(e) => onPropertyChanged(property, e.detail)}
        />
      {/if}
    {/each}
  </div>
</Pane>
